import React from "react";
import IMG1 from "../../assets/portfolio1.jpg";
import IMG2 from "../../assets/upgrad.png";
import hotelBookingImage from "../../assets/kissubooking.png.png";
import pluralsight from "../../assets/pluralsight.png";
import maxfashion from "../../assets/maxfashion.png";
import bitrix24 from "../../assets/bitrix24.png";
import Myfitnesspal from "../../assets/myfitnesspal.png";
import "./Portfolio.css";
export const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Projects</h2>
      <div className="container portfolio__container">
        {/* Forth Project */}
        <article className="portfolio__item">
          <h3>Hotel Booking</h3>
          <div className="portfoli__item-image">
            <img src={hotelBookingImage}></img>
          </div>

          <h5>
            kisshubooking simplifies city room bookings with a unique,
            scratch-built website. We offer seamless booking and feature-rich
            stays, with more on the way. Book now for a better experience.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2">REACT</a>
            <a className="btn2">REDUX</a>
            <a className="btn2">NODEJS</a>
            <a className="btn2">mongDB</a>
            <a className="btn2">EXPRESSJS</a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/Krishukr12/Hotel-Booking"
              target="_blank"
              className="btn"
            >
              Github
            </a>
            <a
              href="https://hotelbooking-pi.vercel.app/"
              target="_blank"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>
        {/* First Project */}
        <article className="portfolio__item">
          <h3>Bitrix24 Clone</h3>
          <div className="portfoli__item-image">
            <img src={bitrix24}></img>
          </div>

          <h5>
            Bitrix24 is an app providing various tools for business like crm
            tools, task management, project management. The app is basically a
            laptop and tab centric and gives best experience when handled with a
            laptop/pc
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2">REACT </a>
            <a className="btn2"> REDUX</a>
            <a className="btn2"> NODEJS</a>
            <a className="btn2"> EPXRESSJS</a>
            <a className="btn2"> MONGODB</a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/Krishukr12/psychotic-cars-5822-Bitrix24.net"
              target="_blank"
              className="btn"
            >
              Github
            </a>
            <a
              href="https://bitrix-24.netlify.app/"
              target="_blank"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>
        {/* Second Project */}

        <article className="portfolio__item">
          <h3>UpGrad Clone</h3>
          <div className="portfoli__item-image">
            <img src={IMG2}></img>
          </div>

          <h5>
            upGrad is India's largest online higher education company providing
            programs in Data Science, Technology, Management and Law, to
            students, working professionals and enterprises
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2">HTML </a>
            <a className="btn2">CSS</a>
            <a className="btn2">JAVASCRIPT</a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/Krishukr12/Clone-of-upgrad.com"
              target="_blank"
              className="btn"
            >
              Github
            </a>
            <a
              href="https://stupendous-alfajores-e52b1e.netlify.app/"
              target="_blank"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>
        {/* Third Project */}

        <article className="portfolio__item">
          <h3>Myfitnesspal Clone</h3>
          <div className="portfoli__item-image">
            <img src={Myfitnesspal}></img>
          </div>

          <h5>
            MyFitnessPal is a company developing a platform for keeping a food
            diary. The platform enables users to browse the food database and
            recipes, track calories with both the web version and mobile apps.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2">REACT</a>
            <a className="btn2">JAVASCRIPT</a>
            <a className="btn2"> NODEJS</a>
            <a className="btn2"> EXPRESSJ</a>
            <a className="btn2"> MONGODB</a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/Krishukr12/smooth-flavor-1645"
              target="_blank"
              className="btn"
            >
              Github
            </a>
            <a
              href="https://myfitnesspal-snowy.vercel.app/"
              target="_blank"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};
